/* frontend/src/pages/BuyerEdit.js */
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import BuyerForm from './BuyerForm';
import api from '../api';

// Shadcn UI components
import { Spinner } from '../components/ui/spinner';

export default function BuyerEdit() {
  const { id } = useParams();
  const { t } = useTranslation();
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get(`/compradores/${id}`).then(r => setData(r.data));
  }, [id]);

  /* ---------- loading ---------- */
  if (!data) {
    return (
      <div className="container mx-auto px-4 mt-4 mb-6">
        <div className="min-h-[400px] flex flex-col items-center justify-center gap-4 bg-background border rounded-lg p-6">
          <Spinner className="h-10 w-10 text-primary" />
          <p className="text-muted-foreground">
            {t('pages.buyerEdit.loading')}
          </p>
        </div>
      </div>
    );
  }

  /* ---------- edição ---------- */
  return <BuyerForm mode="edit" defaults={data} id={id} />;
}
